module.exports = __webpack_public_path__ + "static/media/16UNODC20.d0514c75.jpg";